import { ScheduleRecordProperty } from '@indigohive/cogfy-types'
import { FieldCellProps } from '../../FieldCell'
import { FormattedDate } from '../../../../components'

export type ScheduleCellProps = Pick<FieldCellProps<ScheduleRecordProperty>, 'property'>

export function ScheduleCell (props: ScheduleCellProps) {
  const { property } = props

  const value = property?.schedule?.value
  const nextDate = property?.schedule?.value?.nextDate
  const endDate = property?.schedule?.value?.endDate
  const maxOccurrences = property?.schedule?.value?.maxOccurrences
  const occurrences = property?.schedule?.value?.count ?? 0

  const hasEndedByOccurrences = maxOccurrences && occurrences >= maxOccurrences
  const hasEndedByEndDate = endDate && new Date(endDate) < new Date()
  const hasEnded = hasEndedByOccurrences || hasEndedByEndDate

  return (
    <div className="flex gap-2 items-center w-full px-2 py-1">
      <div className="grow">
        {value && (
          <div className="flex flex-col gap-2">
            {!hasEnded && nextDate && <span>Next at <FormattedDate date={nextDate} format="Pp" /></span>}

            {!hasEnded && endDate && !maxOccurrences && <span>End at <FormattedDate date={endDate} format="Pp" /></span>}
            {!hasEnded && endDate && maxOccurrences && <span>End at <FormattedDate date={endDate} format="Pp" /> or after {maxOccurrences} occurrences</span>}
            {!hasEnded && !endDate && maxOccurrences && <span>End after {maxOccurrences} occurrences</span>}

            {hasEndedByEndDate && <span>Ended at <FormattedDate date={endDate} format="Pp" /></span>}
            {hasEndedByOccurrences && <span>Ended after {maxOccurrences} occurrences</span>}
          </div>
        )}
      </div>
      <div className="opacity-70 text-xs flex flex-col gap-2">
        <div>
          {value?.unit === 'minutes' && value.interval === 1 && 'Every minute'}
          {value?.unit === 'minutes' && value.interval > 1 && `Every ${value.interval} minutes`}
          {value?.unit === 'hours' && value.interval === 1 && 'Every hour'}
          {value?.unit === 'hours' && value.interval > 1 && `Every ${value.interval} hours`}
          {value?.unit === 'days' && value.interval === 1 && 'Every day'}
          {value?.unit === 'days' && value.interval > 1 && `Every ${value.interval} days`}
          {value?.unit === 'weeks' && value.interval === 1 && 'Every week'}
          {value?.unit === 'weeks' && value.interval > 1 && `Every ${value.interval} weeks`}
          {value?.unit === 'months' && value.interval === 1 && 'Every month'}
          {value?.unit === 'months' && value.interval > 1 && `Every ${value.interval} months`}
        </div>
        {maxOccurrences && value?.count !== null && (
          <div>
            {value?.count === 1 && '1 occurrence'}
            {value?.count !== 1 && `${value?.count} occurrences`}
          </div>
        )}
      </div>
    </div>
  )
}
